import { useState } from "react";
import { FileArchive, X } from "lucide-react";
import { ExportSheet } from "./ExportSheet";

const ym = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
const lastMonth = () => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); return ym(d); };
export const markExported = (month) => { const s = JSON.parse(localStorage.getItem("dropit-exports") || "{}"); s[month] = Date.now(); localStorage.setItem("dropit-exports", JSON.stringify(s)); };

/** 1st–7th of the month: nudge to export last month's completed jobs if not exported yet. */
export const ExportNudge = ({ dispatches }) => {
  const [open, setOpen] = useState(false);
  const [, bump] = useState(0);
  const month = lastMonth();
  const day = new Date().getDate();
  const exported = JSON.parse(localStorage.getItem("dropit-exports") || "{}")[month];
  const dismissed = localStorage.getItem(`dropit-export-nudge-${month}`);
  const count = (dispatches || []).filter((d) => d.status === "completed" && d.completed_at && ym(new Date(d.completed_at)) === month).length;
  if (day > 7 || exported || dismissed || !count) return null;
  const label = new Date(`${month}-01T00:00:00`).toLocaleDateString(undefined, { month: "long" });
  return (<>
    <div className="card install-card fade-up" data-testid="export-nudge">
      <FileArchive className="text-primary" size={22} />
      <div className="flex-1"><p className="font-bold">Your {label} job reports are ready</p><p className="text-sm text-muted">{count} completed job{count === 1 ? "" : "s"} — export the ZIP for invoicing.</p></div>
      <button type="button" className="btn-primary w-auto px-4" onClick={() => setOpen(true)} data-testid="export-nudge-button">Export</button>
      <button type="button" className="icon-btn" onClick={() => { localStorage.setItem(`dropit-export-nudge-${month}`, "1"); bump((n) => n + 1); }} aria-label="Dismiss" data-testid="export-nudge-dismiss"><X size={16} /></button>
    </div>
    {open && <ExportSheet onClose={() => { setOpen(false); bump((n) => n + 1); }} initialMonth={month} />}
  </>);
};
